import React, { useEffect, useState } from 'react';
import styles from './CaseArchiveDetailed.module.scss';
import { BackButton } from '@/components/BackButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { getCaseData, getLeaderboard } from '@/api/modules/Case/case';
import CaseArchiveBanner from './CaseArchiveBanner';
import CaseLeaderboard from '../CaseLeaderboard';
import { Loader } from '@/components/Loader/Loader';

const CaseArchiveDetailed = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [caseData, setCaseData] = useState<any>(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCaseData = async () => {
      setLoading(true);
      try {
        const res = await getCaseData(params.id || '');
        setCaseData(res);
        console.log(res, 'CASE DATA');

        // Получаем лидерборд для этого кейса
        const leaderinfo = await getLeaderboard(params.id || '');
        console.log(leaderinfo, 'LEADERBOARD');
        setLeaderboard(leaderinfo);
      } catch (error) {
        console.error('Ошибка при загрузке данных:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCaseData();
  }, [params.id]);

  const handleBackClick = () => {
    navigate('/case/archive');
  };

  useEffect(() => {
    useNavMenuStore.getState().setVisibility(false);
    return () => {
      useNavMenuStore.getState().setVisibility(true);
    };
  }, []);

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <BackButton onClick={handleBackClick} />
      <div className={styles.content}>
        {caseData && <CaseArchiveBanner caseData={caseData} />}
        {caseData && <CaseLeaderboard leaderboard={leaderboard} />}
      </div>
    </div>
  );
};

export default CaseArchiveDetailed;
